'use strict'
import { request } from '../../plugins/http'

export default async (callId) => {
    return await request.get('/mensagemAtendimento', {params:{callId}})
}